import { Box, Chip, ChipProps, SxProps, Theme } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';

interface YearCardProps {
    href: string;
    variant?: ChipProps['variant'];
    year?: string;
}

const chipSx: SxProps<Theme> = {
    '&:hover': {
        backgroundColor: 'grey.600',
    },
    backgroundColor: 'grey.700',
    color: 'grey.100',
    p: 1,
};

const YearCard: FC<YearCardProps> = ({ href, variant, year }) => {
    const { t } = useTranslation('sitemap');
    const label = year || t('noYearKnown');

    return (
        <Box width="100%">
            <Chip
                key={year}
                component="a"
                data-test-id={`year-${year}`}
                href={href}
                label={label}
                sx={chipSx}
                variant={variant}
                clickable
            />
        </Box>
    );
};

export default YearCard;
